"use client";

import * as React from "react";
import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import HeroAnimation from "./hero-animation";

const ROTATING_WORDS = [
  {
    text: "flashcards",
    textClass: "text-emerald-500",
    underlineClass: "bg-emerald-500/40 w-42",
  },
  {
    text: "quizzes",
    textClass: "text-orange-500",
    underlineClass: "bg-orange-500/40 w-30",
  },
  {
    text: "summaries",
    textClass: "text-blue-500",
    underlineClass: "bg-blue-500/40 w-45",
  },
  // {
  //   text: "study guides",
  //   textClass: "text-purple-500",
  //   underlineClass: "bg-purple-500/40 w-50",
  // },
  // {
  //   text: "notes",
  //   textClass: "text-cyan-500",
  //   underlineClass: "bg-cyan-500/40 w-24",
  // },
];

export function StudyHero() {
  const [index, setIndex] = React.useState(0);
  const [isExiting, setIsExiting] = React.useState(false);

  React.useEffect(() => {
    const id = setInterval(() => {
      setIsExiting(true);
      setTimeout(() => {
        setIndex((i) => (i + 1) % ROTATING_WORDS.length);
        setIsExiting(false);
      }, 500);
    }, 2500);

    return () => clearInterval(id);
  }, []);

  const current = ROTATING_WORDS[index];

  return (
    <div className="relative mb-20 overflow-visible">
      <div className="flex items-start justify-between gap-6">
        <div className="max-w-2xl space-y-3">
          <h1 className="text-4xl font-bold leading-tight text-theme-0">
            Study smarter with {/* underline accent */}
            <span
              className="relative inline-block align-bottom"
              style={{ minWidth: "220px" }}
            >
              <span
                className={cn(
                  "inline-block transition-all ease-in-out",
                  "duration-500 relative z-10",
                  current.textClass,
                  isExiting
                    ? "-translate-y-6 opacity-0"
                    : "translate-y-0 opacity-100"
                )}
              >
                {current.text}.
              </span>

              {/* underline */}
              <span
                className={cn(
                  "absolute left-0 -bottom-[6px]",
                  "h-[3px] rounded-full",
                  "transition-opacity duration-500",
                  "z-0",
                  current.underlineClass,
                  isExiting ? "opacity-0" : "opacity-100"
                )}
              />
            </span>
          </h1>

          <p className="text-lg text-theme-1">
            Instantly transform your course files into personalized study
            materials!
          </p>
        </div>
        <HeroAnimation />
      </div>
    </div>
  );
}
